import React, { useEffect } from "react";
import { useImmer } from "use-immer";

import {
  IgButton,
  IgSelect,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import {
  IntegrationStatus,
  IntegrationStatusList,
} from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { usePatchOrganization } from "@src/api/organizations/patch-organization";

import Loading from "../../../utils/Loading";

export const IntegrationStatusSwitcher = () => {
  const mutateIntegrationStatus = usePatchOrganization();
  const organization = useGetOrg();

  const [currStatus, setCurrStatus] = useImmer<IntegrationStatus | undefined>(
    organization?.data?.org.integrationStatus
  );

  useEffect(() => {
    if (
      organization &&
      organization.data.org.integrationStatus &&
      !currStatus
    ) {
      setCurrStatus(organization.data.org.integrationStatus);
    }
  }, [organization]);

  if (organization.isSuccess) {
    return (
      <Grid container direction={"column"} rowSpacing={3}>
        <Grid item xs>
          <IgTypography variant="h3" fontWeight={"fontWeightMedium"}>
            Integration Status Switcher
          </IgTypography>
        </Grid>
        <Grid container item direction={"row"} columnSpacing={2}>
          <Grid item>
            <IgTooltip
              title={"Mark as integration_complete to bypass igPrice tagging"}
              placement={"top"}
            >
              <IgSelect
                sx={{ width: "200px" }}
                value={currStatus}
                onChange={(e) => {
                  setCurrStatus(e.target.value);
                }}
              >
                {Object.values(IntegrationStatusList).map((status, index) => (
                  <MenuItem value={status} key={index}>
                    {status}
                  </MenuItem>
                ))}
              </IgSelect>
            </IgTooltip>
          </Grid>
          <Grid item xs>
            <IgButton
              disabled={organization.data.org.integrationStatus === currStatus}
              loading={mutateIntegrationStatus.isPending}
              variant="contained"
              onClick={() => {
                mutateIntegrationStatus.mutate({
                  body: {
                    integrationStatus: currStatus,
                  },
                  queryParams: undefined,
                  pathParams: undefined,
                });
              }}
            >
              Save Integration Status
            </IgButton>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return <Loading />;
};
